export type QuickCreateCatalogSlice =
    | {
          wasAttempted: false;
      }
    | {
          bidderLink: string;
          catalogId: number;
          mainhostLink: string;
          wasAttempted: true;
          wasSuccess: true;
      }
    | {
          errorMessage: string;
          wasAttempted: true;
          wasSuccess: false;
      };

export const defaultQuickCreateCatalogSlice: QuickCreateCatalogSlice = {
    wasAttempted: false,
};

export type QuickCreateCatalog = {
    auctioneerPaysFees: boolean;
    autoPay: boolean;
    /**
     * Only allow catalogs to be created for Acme Auction House
     */
    houseId: 869;
    instantAutopay: boolean;
    numBidders: number;
    numLots: number;
    /**
     * S - In-House Shipping
     * L - LiveShipping
     * B - Bidder Shipping
     * P - Pick-up
     * Should have only zero or one of each letter.
     */
    shippingMethods: ('S' | 'L' | 'B' | 'P')[];
    /**
     * @default 3 - The Packengers
     */
    shippingProviderId: number;
    /**
     * Should only create catalog without doing any bidding
     */
    skipBidding: boolean;
    title: string;
};

export type QuickCreateCatalogInvoice = {
    bidderEmail: string;
    bidderId: number;
    invoiceId: number;
    /**
     * Link to the invoice page in hardboiled/partners site
     */
    link: string;
};

export type QuickCreateCatalogSuccessPayload = {
    /**
     * bidder-react auction url
     */
    auction: string;
    catalogId: number;
    /**
     * mainhost auction url
     */
    eoaPage: string;
    invoices: QuickCreateCatalogInvoice[];
};
